<template>
    <h1>Test View</h1>
</template>
<script>
export default {
    name: 'TestView',
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss" scoped=""></style>
